<template lang="html">
  <div class="startup_page" id="content">
    <div class="container content_div">
      <div class="row">
        <table class="desktopDisplay">
          <tr>
            <td class="startupA">
              <div class="startup_compare_header ">

                        <span class="startup_name">{{startupA.name}}</span>
                      </div>
            </td>
            <td class="startupB">
              <div class="startup_compare_header ">
                <span class="startup_name">{{startupB.name}}</span>
              </div>
            </td>
          </tr>
          <tr v-if="startupA.product_category || startupB.product_category">
            <td class="startupA">
              <StartupInfoLine  className="noBorder" v-if="startupA.product_category" name="Innovation category" :value="startupA.product_category" />
                <StartupInfoLine className="noBorder"  v-else name="Innovation category" value="No data" />
            </td>
            <td class="startupB">
              <StartupInfoLine  className="noBorder"  color_info="innopearl_purple"  v-if="startupB.product_category" name="Innovation category" :value="startupB.product_category" />
                <StartupInfoLine className="noBorder"  color_info="innopearl_purple"   v-else name="Innovation category" value="No data" />
            </td>
          </tr>
          <tr  v-if="startupA.solution || startupB.solution" >
            <td class="startupA">
                        <StartupInfoLine className="noBorder"  v-if="startupA.solution" name="solution" :value="startupA.solution"/>
                          <StartupInfoLine className="noBorder"  v-else name="solution" value="No data" />
            </td>
            <td class="startupB">
                      <StartupInfoLine className="noBorder" color_info="innopearl_purple" v-if="startupB.solution" name="solution" :value="startupB.solution"/>
                        <StartupInfoLine className="noBorder"   color_info="innopearl_purple"  v-else name="solution" value="No data" />
            </td>
          </tr>

          <tr  v-if="startupA.innovation_area || startupB.innovation_area" >
            <td class="startupA">
                        <StartupInfoLine className="noBorder"  v-if="startupA.innovation_area" name="Innovation area" :value="startupA.innovation_area" :isArray="true"/>
                          <StartupInfoLine className="noBorder"  v-else name="innovation area" value="No data" />
            </td>
            <td class="startupB">
                      <StartupInfoLine className="noBorder" color_info="innopearl_purple" v-if="startupB.innovation_area" name="Innovation area" :value="startupB.innovation_area" :isArray="true"/>
                        <StartupInfoLine className="noBorder"  v-else name="innovation area"  color_info="innopearl_purple"  value="No data" />
            </td>
          </tr>

          <tr  v-if="startupA.development_stage || startupB.development_stage" >
            <td class="startupA">
                        <StartupInfoLine className="noBorder"  v-if="startupA.development_stage" name="Solution development stage" :value="startupA.development_stage"/>
                          <StartupInfoLine className="noBorder"  v-else name="Solution development stage" value="No data" />
            </td>
            <td class="startupB">
                      <StartupInfoLine className="noBorder" color_info="innopearl_purple" v-if="startupB.development_stage" name="Solution development stage" :value="startupB.development_stage"/>
                        <StartupInfoLine className="noBorder"  v-else name="Solution development stage"  color_info="innopearl_purple"  value="No data" />
            </td>
          </tr>

          <tr  v-if="startupA.funding_stage || startupB.funding_stage" >
            <td class="startupA">
                        <StartupInfoLine className="noBorder"  v-if="startupA.funding_stage" name="funding stage" :value="startupA.funding_stage"/>
                          <StartupInfoLine className="noBorder"  v-else name="funding stage" value="No data" />
            </td>
            <td class="startupB">
                      <StartupInfoLine className="noBorder" color_info="innopearl_purple" v-if="startupB.funding_stage" name="funding stage" :value="startupB.funding_stage"/>
                        <StartupInfoLine className="noBorder"  v-else name="funding stage"  color_info="innopearl_purple"  value="No data" />
            </td>
          </tr>

          <tr  v-if="startupA.value_proposition || startupB.value_proposition" >
            <td class="startupA">
                        <StartupInfoLine className="noBorder"  v-if="startupA.value_proposition" name="value proposition" :value="startupA.value_proposition"/>
                          <StartupInfoLine className="noBorder"  v-else name="value_proposition" value="No data" />
            </td>
            <td class="startupB">
                      <StartupInfoLine className="noBorder" color_info="innopearl_purple" v-if="startupB.value_proposition" name="value proposition" :value="startupB.value_proposition"/>
                        <StartupInfoLine className="noBorder"  v-else name="value_proposition"  color_info="innopearl_purple"  value="No data" />
            </td>
          </tr>

          <tr  v-if="startupA.key_benefits || startupB.key_benefits" >
            <td class="startupA">
                        <StartupInfoLine className="noBorder"  v-if="startupA.key_benefits" name="key benefits" :value="startupA.key_benefits" :isArray="Array.isArray(startupA.key_benefits)"/>
                          <StartupInfoLine className="noBorder"  v-else name="key benefits" value="No data" />
            </td>
            <td class="startupB">
                      <StartupInfoLine className="noBorder" color_info="innopearl_purple" v-if="startupB.key_benefits" name="key benefits" :value="startupB.key_benefits" :isArray="Array.isArray(startupB.key_benefits)"/>
                        <StartupInfoLine className="noBorder"  v-else name="key benefits"  color_info="innopearl_purple"  value="No data" />
            </td>
          </tr>

          <tr  v-if="startupA.market_validation || startupB.market_validation" >
            <td class="startupA">
                        <StartupInfoLine className="noBorder"  v-if="startupA.market_validation" name="market fit evidence" :value="startupA.market_validation"  :isBoolean="true"/>
                          <StartupInfoLine className="noBorder"  v-else name="market_validation" value="No data" />
            </td>
            <td class="startupB">
                      <StartupInfoLine className="noBorder" color_info="innopearl_purple" v-if="startupB.market_validation" name="market fit evidence" :value="startupB.market_validation"  :isBoolean="true"/>
                        <StartupInfoLine className="noBorder"  v-else name="market_validation"  color_info="innopearl_purple"  value="No data" />
            </td>
          </tr>


          <tr  v-if="startupA.business_model || startupB.business_model" >
            <td class="startupA">
                        <StartupInfoLine className="noBorder"  v-if="startupA.business_model" name="business model" :value="startupA.business_model" :isArray="Array.isArray(startupA.business_model)"/>
                          <StartupInfoLine className="noBorder"  v-else name="business model" value="No data" />
            </td>
            <td class="startupB">
                      <StartupInfoLine className="noBorder" color_info="innopearl_purple" v-if="startupB.business_model" name="business model" :value="startupB.business_model" :isArray="Array.isArray(startupB.business_model)"/>
                        <StartupInfoLine className="noBorder"  v-else name="business model"  color_info="innopearl_purple"  value="No data" />
            </td>
          </tr>

          <tr  v-if="startupA.markets || startupB.markets" >
            <td class="startupA">
                        <StartupInfoLine className="noBorder"  v-if="startupA.markets" name="markets" :value="startupA.markets"  :isArray="true"/>
                          <StartupInfoLine className="noBorder"  v-else name="markets" value="No data" />
            </td>
            <td class="startupB">
                      <StartupInfoLine className="noBorder" color_info="innopearl_purple" v-if="startupB.markets" name="markets" :value="startupB.markets"  :isArray="true"/>
                        <StartupInfoLine className="noBorder"  v-else name="markets"  color_info="innopearl_purple"  value="No data" />
            </td>
          </tr>

          <tr  v-if="startupA.assets || startupB.assets" >
            <td class="startupA">
                        <StartupInfoLine className="noBorder"  v-if="startupA.assets" name="Assets" :value="startupA.assets"  :isArray="true"/>
                          <StartupInfoLine className="noBorder"  v-else name="Assets" value="No data" />
            </td>
            <td class="startupB">
                      <StartupInfoLine className="noBorder" color_info="innopearl_purple" v-if="startupB.assets" name="Assets" :value="startupB.assets"  :isArray="true"/>
                        <StartupInfoLine className="noBorder"  v-else name="Assets"  color_info="innopearl_purple"  value="No data" />
            </td>
          </tr>
          <tr  v-if="startupA.skills || startupB.skills" >
            <td class="startupA">
                        <StartupInfoLine className="noBorder"  v-if="startupA.skills" name="Core capabilities" :value="startupA.skills"  :isArray="true"/>
                          <StartupInfoLine className="noBorder"  v-else name="Core capabilities" value="No data" />
            </td>
            <td class="startupB">
                      <StartupInfoLine className="noBorder" color_info="innopearl_purple" v-if="startupB.skills" name="Core capabilities" :value="startupB.skills"  :isArray="true"/>
                        <StartupInfoLine className="noBorder"  v-else name="Core capabilities"  color_info="innopearl_purple"  value="No data" />
            </td>
          </tr>
          <tr  v-if="startupA.paying_customers || startupB.paying_customers" >
            <td class="startupA">
                        <StartupInfoLine className="noBorder"  v-if="startupA.paying_customers" name="Paying customers" :value="startupA.paying_customers"  :isBoolean="true"/>
                          <StartupInfoLine className="noBorder"  v-else name="Paying customers" value="No data" />
            </td>
            <td class="startupB">
                      <StartupInfoLine className="noBorder" color_info="innopearl_purple" v-if="startupB.paying_customers" name="Paying customers" :value="startupB.paying_customers"  :isBoolean="true"/>
                        <StartupInfoLine className="noBorder"  v-else name="Paying customers"  color_info="innopearl_purple"  value="No data" />
            </td>
          </tr>

          <tr  v-if="startupA.woman_cofounder || startupB.woman_cofounder" >
            <td class="startupA">
                        <StartupInfoLine className="noBorder"  v-if="startupA.woman_cofounder" name="woman (co)founder" :value="startupA.woman_cofounder"  :isBoolean="true"/>
                          <StartupInfoLine className="noBorder"  v-else name="woman (co)founder" value="No data" />
            </td>
            <td class="startupB">
                      <StartupInfoLine className="noBorder" color_info="innopearl_purple" v-if="startupB.woman_cofounder" name="woman (co)founder" :value="startupB.woman_cofounder"  :isBoolean="true"/>
                        <StartupInfoLine className="noBorder"  v-else name="woman (co)founder"  color_info="innopearl_purple"  value="No data" />
            </td>
          </tr>

          <tr  v-if="startupA.team_size || startupB.team_size" >
            <td class="startupA">
                        <StartupInfoLine className="noBorder"  v-if="startupA.team_size" name="team size" :value="startupA.team_size" />
                          <StartupInfoLine className="noBorder"  v-else name="team size" value="No data" />
            </td>
            <td class="startupB">
                      <StartupInfoLine className="noBorder" color_info="innopearl_purple" v-if="startupB.team_size" name="team size" :value="startupB.team_size" />
                        <StartupInfoLine className="noBorder"  v-else name="team size"  color_info="innopearl_purple"  value="No data" />
            </td>
          </tr>

          <tr  v-if="startupA.IP || startupB.IP" >
            <td class="startupA">
                        <StartupInfoLine className="noBorder"  v-if="startupA.IP" name="IP" :value="startupA.IP" :isArray="true"/>
                          <StartupInfoLine className="noBorder"  v-else name="IP" value="No data" />
            </td>
            <td class="startupB">
                      <StartupInfoLine className="noBorder" color_info="innopearl_purple" v-if="startupB.IP" name="IP" :value="startupB.IP" :isArray="true"/>
                        <StartupInfoLine className="noBorder"  v-else name="IP"  color_info="innopearl_purple"  value="No data" />
            </td>
          </tr>

          <tr  v-if="startupA.data_available || startupB.data_available" >
            <td class="startupA">
              <StartupInfoLine className="noBorder"  v-if="startupA.data_available" name="Data available" :value="startupA.data_available" :isArray="true"/>
              <StartupInfoLine className="noBorder"  v-else name="Data available" value="No data" />
            </td>
            <td class="startupB">
              <StartupInfoLine className="noBorder" color_info="innopearl_purple" v-if="startupB.data_available" name="Data available" :value="startupB.data_available" :isArray="true"/>
              <StartupInfoLine className="noBorder"  v-else name="Data available"  color_info="innopearl_purple"  value="No data" />
            </td>
          </tr>
          <tr  v-if="startupA.regulatory_status || startupB.regulatory_status" >
            <td class="startupA">
              <StartupInfoLine className="noBorder"  v-if="startupA.regulatory_status" name="Regulatory status" :value="startupA.regulatory_status" />
              <StartupInfoLine className="noBorder"  v-else name="Regulatory status" value="No data" />
            </td>
            <td class="startupB">
              <StartupInfoLine className="noBorder" color_info="innopearl_purple" v-if="startupB.regulatory_status" name="Regulatory status" :value="startupB.regulatory_status" />
              <StartupInfoLine className="noBorder"  v-else name="Regulatory status"  color_info="innopearl_purple"  value="No data" />
            </td>
          </tr>
          <tr  v-if="startupA.patents || startupB.patents" >
            <td class="startupA">
              <StartupInfoLine className="noBorder"  v-if="startupA.patents" name="Patents" :value="startupA.patents" />
              <StartupInfoLine className="noBorder"  v-else name="Patents" value="No data" />
            </td>
            <td class="startupB">
              <StartupInfoLine className="noBorder" color_info="innopearl_purple" v-if="startupB.patents" name="Patents " :value="startupB.patents" />
              <StartupInfoLine className="noBorder"  v-else name="Patents"  color_info="innopearl_purple"  value="No data" />
            </td>
          </tr>
          <tr  v-if="startupA.other_protections || startupB.other_protections" >
            <td class="startupA">
              <StartupInfoLine className="noBorder"  v-if="startupA.other_protections" name="Other forms of protection" :value="startupA.other_protections" />
              <StartupInfoLine className="noBorder"  v-else name="Other forms of protection" value="No data" />
            </td>
            <td class="startupB">
              <StartupInfoLine className="noBorder" color_info="innopearl_purple" v-if="startupB.other_protections" name="Other forms of protection" :value="startupB.other_protections"/>
              <StartupInfoLine className="noBorder"  v-else name="Other forms of protection"  color_info="innopearl_purple"  value="No data" />
            </td>
          </tr>

          <tr>
            <td>
              <div class="actionBtn">
                <a class="prev_step_btn"  v-if="startupA.report"  target="_blank" :href="this.apiUrl+'/get_image/'+startupA.report.$oid+'?token='+$store.state.innotoken">
                  <img :src="require('@/assets/greyDownload.svg')" alt="">
                  Download full report
                </a>
                <a class="prev_step_btn" :href="'/startup_report/'+this.$route.params.searchfield+'/'+startupA._id.$oid+'/'+this.$route.params.projectid" v-if="startupA._id">
                  <img :src="require('@/assets/eye.svg')" alt="">
                  see full report
                </a>
              </div>
            </td>
            <td>
              <div class="actionBtn">
                <a class="prev_step_btn"  v-if="startupB.report"  target="_blank" :href="this.apiUrl+'/get_image/'+startupB.report.$oid+'?token='+$store.state.innotoken">
                  <img :src="require('@/assets/greyDownload.svg')" alt="">
                  Download full report
                </a>
                <a class="prev_step_btn" :href="'/startup_report/'+this.$route.params.searchfield+'/'+startupB._id.$oid+'/'+this.$route.params.projectid" v-if="startupA._id">
                  <img :src="require('@/assets/eye.svg')" alt="">
                  see full report
                </a>
              </div>
            </td>
          </tr>
        </table>
        <div class="mobileDisplay">


        <div class="col-12 col-lg-6 startupA">
          <div class="startup_compare_header ">

            <span class="startup_name">{{startupA.name}}</span>
          </div>
          <StartupInfoLine  className="noBorder" v-if="startupA.product_category" name="Innovation category" :value="startupA.product_category" />

                    <StartupInfoLine className="noBorder"  v-if="startupA.solution" name="solution" :value="startupA.solution"/>

                    <StartupInfoLine className="noBorder"  v-if="startupA.innovation_area" name="Innovation area" :value="startupA.innovation_area" :isArray="true"/>

                    <StartupInfoLine className="noBorder"  v-if="startupA.development_stage" name="Solution development stage" :value="startupA.development_stage"/>

                    <StartupInfoLine className="noBorder"  v-if="startupA.funding_stage" name="funding stage" :value="startupA.funding_stage"/>

                    <StartupInfoLine className="noBorder"  v-if="startupA.value_proposition" name="value proposition" :value="startupA.value_proposition"/>

                    <StartupInfoLine className="noBorder"  v-if="startupA.key_benefits" name="key benefits" :value="startupA.key_benefits" :isArray="Array.isArray(startupA.key_benefits)"/>

                    <StartupInfoLine className="noBorder"  v-if="startupA.market_validation" name="market fit evidence" :value="startupA.market_validation"  :isBoolean="true"/>

                    <StartupInfoLine className="noBorder"  v-if="startupA.funding_stage" name="funding stage" :value="startupA.funding_stage"/>

                    <StartupInfoLine className="noBorder"  v-if="startupA.business_model" name="business model" :value="startupA.business_model" :isArray="Array.isArray(startupA.business_model)"/>

                    <StartupInfoLine className="noBorder"  v-if="startupA.markets" name="markets" :value="startupA.markets"  :isArray="true"/>

                    <StartupInfoLine className="noBorder"  v-if="startupA.assets" name="Assets" :value="startupA.assets"  :isArray="true"/>

                    <StartupInfoLine className="noBorder"  v-if="startupA.skills" name="Core capabilities" :value="startupA.skills"  :isArray="true"/>

                    <StartupInfoLine className="noBorder"  v-if="startupA.paying_customers" name="Paying customers" :value="startupA.paying_customers"  :isBoolean="true"/>

                    <StartupInfoLine className="noBorder"  v-if="startupA.woman_cofounder" name="woman (co)founder" :value="startupA.woman_cofounder"  :isBoolean="true"/>

                    <StartupInfoLine className="noBorder"  v-if="startupA.team_size" name="team size" :value="startupA.team_size" />

                    <StartupInfoLine className="noBorder"  v-if="startupA.IP" name="IP" :value="startupA.IP" :isArray="true"/>

                    <StartupInfoLine className="noBorder"  v-if="startupA.data_available" name="Data available" :value="startupA.data_available" :isArray="true"/>
                    <StartupInfoLine className="noBorder"  v-if="startupA.regulatory_status" name="Regulatory status" :value="startupA.regulatory_status" />
                    <StartupInfoLine className="noBorder"  v-if="startupA.patents" name="Patents" :value="startupA.patents" />
                    <StartupInfoLine className="noBorder"  v-if="startupA.other_protections" name="Other forms of protection" :value="startupA.other_protections" />

                    <!-- <StartupInfoLine className="noBorder"  v-if="startupA.fte" name="fte" :value="startupA.fte" /> -->

          <div class="actionBtn">
            <a class="prev_step_btn"  v-if="startupA.report"  target="_blank" :href="this.apiUrl+'/get_image/'+startupA.report.$oid+'?token='+$store.state.innotoken">
              <img :src="require('@/assets/greyDownload.svg')" alt="">
              Download full report
            </a>
            <a class="prev_step_btn" :href="'/startup_report/'+this.$route.params.searchfield+'/'+startupA._id.$oid+'/'+this.$route.params.projectid" v-if="startupA._id">
              <img :src="require('@/assets/eye.svg')" alt="">
              see full report
            </a>
          </div>
        </div>
        <div class="col-12 col-lg-6 startupB">
          <div class="startup_compare_header">
            <span class="startup_name">{{startupB.name}}</span>
          </div>
          <StartupInfoLine  className="noBorder"  color_info="innopearl_purple"  v-if="startupB.product_category" name="Innovation category" :value="startupB.product_category" />

                  <StartupInfoLine className="noBorder" color_info="innopearl_purple" v-if="startupB.solution" name="solution" :value="startupB.solution"/>

                  <StartupInfoLine className="noBorder" color_info="innopearl_purple" v-if="startupB.innovation_area" name="Innovation area" :value="startupB.innovation_area" :isArray="true"/>

                  <StartupInfoLine className="noBorder" color_info="innopearl_purple" v-if="startupB.development_stage" name="Solution development stage" :value="startupB.development_stage"/>

                  <StartupInfoLine className="noBorder" color_info="innopearl_purple" v-if="startupB.funding_stage" name="funding stage" :value="startupB.funding_stage"/>

                  <StartupInfoLine className="noBorder" color_info="innopearl_purple" v-if="startupB.value_proposition" name="value proposition" :value="startupB.value_proposition"/>

                  <StartupInfoLine className="noBorder" color_info="innopearl_purple" v-if="startupB.key_benefits" name="key benefits" :value="startupB.key_benefits" :isArray="Array.isArray(startupB.key_benefits)"/>

                  <StartupInfoLine className="noBorder" color_info="innopearl_purple" v-if="startupB.market_validation" name="market fit evidence" :value="startupB.market_validation" :isBoolean="true"/>

                  <StartupInfoLine className="noBorder" color_info="innopearl_purple" v-if="startupB.funding_stage" name="funding stage" :value="startupB.funding_stage"/>

                  <StartupInfoLine className="noBorder" color_info="innopearl_purple" v-if="startupB.business_model" name="business model" :value="startupB.business_model" :isArray="Array.isArray(startupB.business_model)"/>

                  <StartupInfoLine className="noBorder" color_info="innopearl_purple" v-if="startupB.markets" name="markets" :value="startupB.markets"  :isArray="true"/>

                  <StartupInfoLine className="noBorder" color_info="innopearl_purple" v-if="startupB.assets" name="Assets" :value="startupB.assets"  :isArray="true"/>

                  <StartupInfoLine className="noBorder" color_info="innopearl_purple" v-if="startupB.skills" name="Core capabilities" :value="startupB.skills"  :isArray="true"/>

                  <StartupInfoLine className="noBorder" color_info="innopearl_purple" v-if="startupB.paying_customers" name="Paying customers" :value="startupB.paying_customers"  :isBoolean="true"/>

                  <StartupInfoLine className="noBorder" color_info="innopearl_purple" v-if="startupB.woman_cofounder" name="woman (co)founder" :value="startupB.woman_cofounder"  :isBoolean="true"/>

                  <StartupInfoLine className="noBorder" color_info="innopearl_purple" v-if="startupB.team_size" name="team size" :value="startupB.team_size" />

                  <StartupInfoLine className="noBorder" color_info="innopearl_purple" v-if="startupB.IP" name="IP" :value="startupB.IP" :isArray="true"/>

                  <StartupInfoLine className="noBorder"  v-if="startupB.data_available" name="Data available" :value="startupB.data_available" :isArray="true"/>
                  <StartupInfoLine className="noBorder"  v-if="startupB.regulatory_status" name="Regulatory status" :value="startupB.regulatory_status" />
                  <StartupInfoLine className="noBorder"  v-if="startupB.patents" name="Patents" :value="startupB.patents" />
                  <StartupInfoLine className="noBorder"  v-if="startupB.other_protections" name="Other forms of protection" :value="startupB.other_protections" />
                  <!-- <StartupInfoLine className="noBorder" color_info="innopearl_purple" v-if="startupB.fte" name="fte" :value="startupB.fte" /> -->

          <div class="actionBtn" >
            <a class="prev_step_btn"  v-if="startupB.report"  target="_blank" :href="this.apiUrl+'/get_image/'+startupB.report.$oid+'?token='+$store.state.innotoken">
              <img :src="require('@/assets/greyDownload.svg')" alt="">
              Download full report
            </a>
              <a class="prev_step_btn" :href="'/startup_report/'+this.$route.params.searchfield+'/'+startupB._id.$oid+'/'+this.$route.params.projectid" v-if="startupB._id">
              <img :src="require('@/assets/eye.svg')" alt="">
              see full report
            </a>
          </div>
        </div>
      </div>
      </div>

      <div class="row  mt100 ">
        <div class="col-12 col-lg-6 col-xl-6">
          <div class="item_card">
            <span class="item_card_title">READINESS FOR PARTNERSHIP</span>
            <div class="item_card_content" v-if="comparison.readiness_for_partnership">
              <img :src="this.apiUrl+'/get_image/'+comparison.readiness_for_partnership.$oid+'?token='+$store.state.innotoken"  class="img-fluid assessment_report" alt="" @click="visibleRef_readiness = true">

              <vue-easy-lightbox :rotateDisabled='true' :visible="visibleRef_readiness" :imgs="this.apiUrl+'/get_image/'+comparison.readiness_for_partnership.$oid+'?token='+$store.state.innotoken"  @hide="onHide"></vue-easy-lightbox>

              </div>
              <div class="item_card_content" v-else>
                <div class="alert alert-info text-center">
                  Not available
                </div>
              </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 col-xl-6">
          <div class="item_card">
            <span class="item_card_title">STRATEGIC FIT</span>
            <div class="item_card_content" v-if="comparison.strategic_fit">
              <img :src="this.apiUrl+'/get_image/'+comparison.strategic_fit.$oid+'?token='+$store.state.innotoken"  class="img-fluid assessment_report" alt="" @click="visibleRef_strategic_fit = true">

              <vue-easy-lightbox :rotateDisabled='true' :visible="visibleRef_strategic_fit" :imgs="this.apiUrl+'/get_image/'+comparison.strategic_fit.$oid+'?token='+$store.state.innotoken"  @hide="onHide"></vue-easy-lightbox>

              </div>
              <div class="item_card_content" v-else>
                <div class="alert alert-info text-center">
                  Not available
                </div>
              </div>
          </div>
        </div>
      </div>



      <div class="row center mt100 stepfooter">
        <div class="col-12 col-xl-6">
          <button class="prev_step_btn" @click="gobackrouter()">
            <img :src="require('@/assets/prev.svg')" alt="">
            BACK TO YOUR SELECTION
          </button>
        </div>
        <div class="col-12 col-xl-6 text-xl-right" v-if="comparison.comparison_report">
          <a type="button" name="button" class="next_step_btn" :href="this.apiUrl+'/get_image/'+comparison.comparison_report.$oid+'?token='+$store.state.innotoken" target="_blank">
            <img :src="require('@/assets/downloadWhite.svg')" alt="">
            DOWNLOAD COMPARISON REPORT
          </a>
        </div>
      </div>
    </div>

<!--
    <Toaster  position="top-right" :expand="true" richColors closeButton/> -->
  </div>
</template>

<script>
import StartupInfoLine from '@/components/InfoStartupLine.vue'
// import { Toaster, toast } from 'vue-sonner'
import api from '../tools/api';
import { toast } from 'vue-sonner'


export default {
  name : "StartupInfo",
  components: {
    StartupInfoLine,
    // Toaster
  },
  data() {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      startupA : {
      },
      startupB : {
      },
      comparison: {},
      visibleRef_readiness: false,
      visibleRef_strategic_fit: false,
    }
  },
  methods:{
    gobackrouter : function(){
      this.$router.go(-1);
    },
    // submitStartup(){
    //   toast.success("Assessment submit for startup "+this.startup.name);
    //   this.startup.isSubmit = true;
    //   this.$store.commit('UPDATE_NOTIFICATION',1)
    // }
    onHide(){
      this.visibleRef_readiness = false;
      this.visibleRef_strategic_fit = false;
    },
    seeDoc(doc){
        console.log(doc);
        api.get(process.env.VUE_APP_API_URL+"/restrict/get_file/"+doc.$oid).then( (r) => {
          console.log(r);
        })
    },
  },
  mounted(){
          api.get(process.env.VUE_APP_API_URL+"/restrict/search_field/assessment_compare/"+this.$route.params.searchfield+'/'+this.$route.params.a+'/'+this.$route.params.b).then( (r) => {
            // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
            // console.log();
            // var temp = _.merge(this.candidatespool, r.data)
            console.log(r.data);
            this.comparison = r.data.comparisons;
            this.startupA = this.comparison.a;
            this.startupB = this.comparison.b;
            console.log(this.assessment);
          }).catch( (e) => {
            console.log(e);
             toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
  },
}
</script>

<style lang="css" scoped>
.startup_page{
  padding-top:50px;
  padding-bottom: 50px;
  padding: 50px;
}
.content_div{
  /* margin-top:50px;
  margin-bottom: 50px; */
  padding: 50px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
}
.startup_name{
  color: #3783C5;
text-transform: uppercase;
font-size:24px;
line-height: 29px;
}
.startup_website{
margin-top: 10px;

}
.startup_website a{
  font-size:16px;
  line-height: 22px;
  text-decoration: none;
  color: #000;

}
.startup_website img{
  margin-right: 10px;
}
img.startup_banner{
  width: 100%;
  height: 300px;
  object-fit: cover;
  object-position: center;
  margin-top: 50px;
  margin-bottom: 50px;
}

.assessment{
  margin-top:100px;
  margin-bottom: 100px;
}
.item_card{
  border: 1px solid #DDD;
  border-radius: 10px;
padding: 20px;
position:relative;
padding-top: 40px;
margin-top: 20px;
align-content: center;
align-items: center;
align-self: center;
justify-content: center;
display: flex;
height:100%;
}
.item_card .item_card_title{
  position:absolute;
  top: 0px;
  transform: translateY(-50%);
  left: 20px;
  background: #FFF;
  color: #3783C5;
text-transform: uppercase;
font-size:18px;
line-height: 24px;
  padding-left: 20px;
  padding-right: 20px;
}






.barcontainer{
  background-color: #DDDDDD;
  position: relative;
  margin-left: 50px;
  width: 30px;
  height: 200px;
}
.bar{
  background-color: #3783C5;
  position: absolute;
  bottom: 0;
  width: 100%;

  box-sizing: border-box;
  -webkit-transition: all 0.5s linear;
      -moz-transition: all 0.5s linear;
      -o-transition: all 0.5s linear;
      transition: all 0.5s linear;
  transform-origin: bottom;
}
.bar.low{
  height: 10%;
}
.bar.medium{
  height: 50%;
}

.bar.high{
  height: 90%;

}

@keyframes grow{
  from{
    transform: scaleY(0);
  }
}

.jauge_label.low{
  position: absolute;
  bottom :10%;
  transform: translateY(50%);
  right: -210px;
  width: 200px;
  padding-left: 10px;
  display: flex;
  align-items: center;
}

.jauge_label.medium{
  position: absolute;
  bottom :50%;
  transform: translateY(50%);
  right: -210px;
  width: 200px;
  padding-left: 10px;
  display: flex;
  align-items: center;
}


.jauge_label.high{
  position: absolute;
  top :10%;
  transform: translateY(-50%);
  right: -210px;
  width: 200px;
  padding-left: 10px;
  display: flex;
  align-items: center;
}

.jauge_label::before{
  content :" ";
  background: #707070;
  width:10px;
  height:1px;
  left: -10px;
  position:absolute;
  top: 50%;
}
.jauge_label input{
  width:22px;
  height:22px;
}

.jauge_label span{
  display:block;
  color: #3783C5;
  font-size: 14px;
  line-height: 22px;
  width:100%;
  font-weight: 500;
  text-transform:uppercase;
}
.jauge_label small{
  color: #575757;
  font-weight: 300;
  font-size:14px;
  line-height: 22px;
}
.info{
    display: flex;
    flex-direction: column;
    padding: 5px;
}

.flex{
  display:flex;
  align-items: center;
    gap: 20px;
}
.barLabel{
  color: #3783C5;
  font-size:18px;
  line-height: 21px;
}
@media screen and (max-width:1200px){
  .flex{
    flex-direction: column;

    align-items: flex-start;
  }
}

.rocker input{
  display: none;
}
.rocker{
  border: 1px solid #3783C5;
border-radius: 50px;padding:5px;
}
.rocker .switch-left{
  padding:5px 30px;
  text-align:center;
  display:inline-block;
  font-size:14px;
  line-height:22px;
  cursor: pointer;
    color:#3783C5;
}
.rocker .switch-right{
  padding:5px 30px;
  text-align:center;
  display:inline-block;
  font-size:14px;
  line-height:22px;
  cursor: pointer;
    color:#3783C5;
}
.rocker input:checked + .switch-left {
  background:#3783C5;
  color: #FFF;
  border-radius: 50px 0 0 50px;
}
.rocker input:not(:checked)+ .switch-left  + .switch-right {
  background:#3783C5;
  color: #FFF;
  border-radius: 0 50px 50px 0  ;
}

.center{
  align-items: center;
}

.mt50{
  margin-top: 50px;
}
.mb50{
  margin-bottom: 50px;
}

.divider-dotted{
  border-bottom:1px dashed #3783C5;
}

.next_step_btn{
  background: #3783C5 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
}
.next_step_btn img.left{
  margin-right:10px;
}

.prev_step_btn{
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#3783C5;
  margin:5px;
}
.prev_step_btn img{
  margin-right:10px;
}

.prev_step_btn{
  text-decoration :none;
}
.contact_step_btn{
  border: 1px solid #575757;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  background:#575757;
  margin:5px;
  text-decoration: none;
}

.roundImage{
  /* border-radius: 50%; */
  width:96px;
  height:96px;
  object-fit: cover;
  object-position: center;
  /* mask: url('~@/assets/mark_yellow.svg#mask'); */
}
.startup_compare_header{
  padding-top:20px;
  padding-bottom: 20px;
}
.startup_compare_header span{
  color: #3783C5;
text-transform: uppercase;
font-size:18px;
line-height: 21px;
}

.startupA .roundImage{
border: 2px solid #B38D2F;
padding: 5px;
border-radius: 50%;
border-right: none;
border-top: none;
margin-right:10px;
}

.startupB .roundImage{
border: 2px solid #6C68A2;
padding: 5px;
border-radius: 50%;
border-right: none;
border-top: none;
margin-right:10px;
}

/* .startupA,
.startupB{
  margin-top:20px;
  margin-bottom: 20px;
  display:flex;
  flex-direction:column;
} */
.startupA .actionBtn,
.startupB .actionBtn{
  margin-top:auto !important;
}
.stepfooter a,
.stepfooter button{
  display:inline-block;
}
@media screen and (max-width:990px){
.stepfooter a,
.stepfooter button{
  display:block;
  width: 100%;
  text-align:center;
}
}
.actionBtn{
  margin-top: 20px;
}
.actionBtn .prev_step_btn{
  text-transform: uppercase;
  padding: 7px 18px;
  display: inline-block;
  font-size:12px;
  line-height: 15px;
}
.actionBtn .prev_step_btn img{
  width:25px;
  height:25px;
  object-fit: contain;
  object-position: center;
}

.mt100{
  margin-top:100px;

}
@media screen and (max-width: 690px){
  .startup_page{
    padding-left:15px;
    padding-right: 15px;
  }
  .content_div{
    padding-right: 20px;
    padding-left: 20px;
  }
}


.vel-img {
  background:#FFF !important;
}
.startupA  .startup_name{
  color:#B38D2F;
}
.startupB  .startup_name{
  color:#6C68A2;
}
.startupC  .startup_name{
  color:#3783C5;
}

td.startupA,
td.startupB{
 width:50%;
 vertical-align: top;
 border-bottom:1px solid #DDD;
 /* padding-left:25px;
 padding-right:25px; */
}
table {
  border-spacing: 20px 10px !important;
  border-collapse: separate;
}

.mobileDisplay{
  display:none;
}
@media screen and (max-width:990px){
  .mobileDisplay{
    display:block;
  }
  .desktopDisplay{
    display:none;
  }
}
.jauge_label{
  text-align:left !important;
}
</style>
